var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoResults = function SvgNoResults(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 133,
    viewBox: "0 0 122 133",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0162457 52.172C-0.431401 36.3552 8.20819 3.91565 46.3477 0.692595C94.0221 -3.33623 99.2018 43.5489 97.8271 52.172C96.3491 61.443 93.2579 74.9888 83.5664 84.7235L121.105 124.691L111.704 132.301L79.4331 88.315C73.2764 92.9236 65.04 96.137 53.9577 96.7127C19.4888 98.5033 1.80691 76.3452 0.0162457 52.172Z",
    fill: "#43AFDE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.911509 51.7244C0.463862 35.9075 9.10345 3.46801 47.243 0.244948C94.9174 -3.78388 100.097 43.1013 98.7223 51.7244C97.3144 60.5559 94.4426 73.2667 85.7958 82.8668L122 124.243L112.599 131.853L80.3284 87.8673C74.1717 92.476 65.9352 95.6893 54.8529 96.265C20.3841 98.0556 2.70217 75.8975 0.911509 51.7244Z",
    fill: "#1E5983"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.911509 51.7244C0.463862 35.9075 9.10345 3.46801 47.243 0.244948C94.9174 -3.78388 100.097 43.1013 98.7223 51.7244C97.3144 60.5559 94.4426 73.2667 85.7958 82.8668L122 124.243L112.599 131.853L80.3284 87.8673C74.1717 92.476 65.9352 95.6893 54.8529 96.265C20.3841 98.0556 2.70217 75.8975 0.911509 51.7244Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 890"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4667 6.06439C13.4456 6.95969 6.28321 38.668 6.95468 54.4103C9.64059 74.7784 27.9941 92.9077 53.9576 91.341C79.9211 89.7742 90.4408 68.2872 92.2314 50.3815C93.4137 38.5588 89.9932 4.94528 47.4667 6.06439Z",
    fill: "#C8D9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4667 6.06439C13.4456 6.95969 6.28321 38.668 6.95468 54.4103C9.64059 74.7784 27.9941 92.9077 53.9576 91.341C79.9211 89.7742 90.4408 68.2872 92.2314 50.3815C93.4137 38.5588 89.9932 4.94528 47.4667 6.06439Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 87,
    height: 86
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 896"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4667 6.06439C13.4456 6.95969 6.28321 38.668 6.95468 54.4103C9.64059 74.7784 27.9941 92.9077 53.9576 91.341C79.9211 89.7742 90.4408 68.2872 92.2314 50.3815C93.4137 38.5588 89.9932 4.94528 47.4667 6.06439Z",
    fill: "#C8D9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4667 6.06439C13.4456 6.95969 6.28321 38.668 6.95468 54.4103C9.64059 74.7784 27.9941 92.9077 53.9576 91.341C79.9211 89.7742 90.4408 68.2872 92.2314 50.3815C93.4137 38.5588 89.9932 4.94528 47.4667 6.06439Z",
    fill: "black",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 894",
    d: "M95.8126 53.0671L29.1132 9.64532C17.4744 8.39191 10.0882 24.6415 7.84998 32.923L88.6503 72.7636L95.8126 53.0671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 895",
    d: "M81.4879 80.5975L5.83558 39.6378L3.82117 47.2478L77.0115 85.9692L81.4879 80.5975Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 892",
    d: "M39.409 38.0711L30.6799 33.8185C35.8279 20.8367 42.3188 20.1653 56.1958 20.8368C70.0729 21.5082 66.4917 36.5044 66.4917 37.3997C66.4917 38.295 65.1488 47.2479 58.6579 49.4862C53.4652 51.2768 53.3607 57.5438 53.9576 60.4535H46.3476C46.0491 58.9614 45.6313 54.9475 46.3476 50.8291C47.2429 45.6812 57.3149 40.5332 57.5388 36.9521C57.7626 33.3709 58.8817 28.8944 49.9288 28.4467C42.7664 28.0886 39.9313 34.7138 39.409 38.0711Z",
    fill: "#1E5983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 893",
    d: "M48.8097 64.4823C44.1542 64.6614 43.2887 68.735 43.4379 70.7494C43.6617 72.9876 45.3628 77.4192 50.3765 77.2402C56.6435 77.0163 55.9721 71.197 55.9721 70.3017C55.9721 69.4064 54.6291 64.2585 48.8097 64.4823Z",
    fill: "#1E5983"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 117.076,
    y1: -83.4652,
    x2: 124.91,
    y2: 132.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43AFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43AFDE",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NoResults.9b086e2b.svg";
export { ForwardRef as ReactComponent };